import { render } from "./PreLoader.vue?vue&type=template&id=2d286b5e&scoped=true&ts=true"
import script from "./PreLoader.vue?vue&type=script&lang=ts"
export * from "./PreLoader.vue?vue&type=script&lang=ts"

import "./PreLoader.vue?vue&type=style&index=0&id=2d286b5e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d286b5e"]])

export default __exports__